import {makeAutoObservable} from "mobx";

class ModifyAddressStore {

    isDefault = false;
    provinceList = [];
    cityList = [];
    districtList = [];

    provinceId = 0;
    cityId = 0;
    districtId = 0;
    currentProvinceId = 0;
    currentCityId = 0;
    currentDistrictId = 0;

    constructor() {
        makeAutoObservable(this)
    }
}

export default new ModifyAddressStore();